import { createResourceLocatorString } from '../../util/routes';

export const createSearchResultSchema = (
  brands,
  mainSearchData,
  intl,
  routeConfiguration,
  config
) => {
  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const marketplaceName = config.marketplaceName;
  const { address, keywords } = mainSearchData;
  const keywordsMaybe = keywords ? `"${keywords}"` : null;
  const searchTitle =
    address || keywordsMaybe || intl.formatMessage({ id: 'SearchBrandsPage.schemaForSearch' });
  const schemaDescription = intl.formatMessage({ id: 'SearchBrandsPage.schemaDescription' });
  const schemaTitle = intl.formatMessage(
    { id: 'SearchBrandsPage.schemaTitle' },
    { searchTitle, marketplaceName }
  );

  const schemaBrands = brands.map((b, i) => {
    const pathToBrand = createResourceLocatorString(
      'SearchPage',
      routeConfiguration,
      {},
      {
        pub_brand: b.id,
      }
    );
    return {
      '@type': 'ListItem',
      position: i,
      url: `${config.marketplaceRootURL}${pathToBrand}`,
      name: b.name,
    };
  });

  const schemaMainEntity = JSON.stringify({
    '@type': 'ItemList',
    name: searchTitle,
    itemListOrder: 'http://schema.org/ItemListOrderAscending',
    itemListElement: schemaBrands,
  });
  return {
    title: schemaTitle,
    description: schemaDescription,
    schema: {
      '@context': 'http://schema.org',
      '@type': 'SearchResultsPage',
      description: schemaDescription,
      name: schemaTitle,
      mainEntity: [schemaMainEntity],
    },
  };
};
